<template>
  <div>
    <!-- Snackbar -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!-- Main Card -->
    <v-card class="main-card">
      <v-toolbar class="custom-toolbar ma-2" flat dense>
        <v-toolbar-title>Last Attended School Information</v-toolbar-title>
      </v-toolbar>

      <v-row class="px-5">
        <v-card flat>
          <v-row dense class="pa-5">
            <!-- Dynamic Fields -->
            <!-- {{schoolAttended}} -->
            <v-col v-for="(field, key) in schoolAttended" :key="key" v-if="field && field.isactive" cols="12" sm="4"
              md="4" class="pt-0">
              <!-- Label -->
              <span class="pl-1 pb-2" style="font-size: 14px;">
                <b>{{ field.displayName }}</b>
              </span>
              <v-icon v-if="field.required" class="pl-1 pb-2" color="error">*</v-icon>

              <!-- Checkbox -->
              <v-checkbox v-if="field.type === 'checkbox'" v-model="field.value" :readonly="!field.iseditable"
                density="compact" class="font-weight-bold" />

              <!-- Text input -->
              <v-text-field v-else-if="field.type === 'text'" v-model.trim="field.value" outlined dense rounded
                :disabled="!field.iseditable" @keypress="handleKeyPress(field, $event)" />



              <!-- Select dropdown -->
              <!-- <v-select v-else-if="field.type === 'select'" v-model="field.value" :items="standard_list"
                item-text="name" item-value="id" outlined rounded dense :disabled="!field.iseditable" /> -->

              <v-select v-else-if="field.type === 'select'" v-model="field.value" :items="field.options"
                item-text="name" item-value="id" outlined rounded dense :disabled="!field.iseditable" />
            </v-col>

            <!-- Save Button -->
            <v-col cols="12" align="center" class="pb-5">
              <v-btn text class="button-77" @click="saveChildPreviousSchoolDetails" :loading="save_loader">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
    </v-card>
  </div>
</template>


<script>
  import axios from "axios";
  export default {
    props: {
      learner: {
        type: [String, Number],
        required: true,
      },
    },

    data() {
      return {
        color: "",
        snackbar: false,
        snackbar_msg: "",
        schoolAttended: {}, // dynamic fields object
        standard_list: [],
        previousschoolschoolboard_list: [],
        save_loader: false,
      };
    },
    watch: {
      learner(newVal) {
        if (newVal) {
          this.getChildPreviousSchoolDetails();
        }
      },
    },
    methods: {
      handleKeyPress(field, event) {
        const key = event.key;

        // For Percentage field: allow only digits and %
        if (field.key === 'previous_school_obtained_percentage' || field.displayName.toLowerCase().includes('percentage')) {
          // Allow digits 0-9 and % only
          if (!/[\d%]/.test(key)) {
            event.preventDefault();
          }
        }

        // For School Name: letters, space, ', ., ,, (, ), -
        else if (this.isSchoolName(field.displayName)) {
          if (!/^[a-zA-Z\s',.\-\(\)]$/.test(key)) {
            event.preventDefault();
          }
        }

        // For School Medium: letters and spaces only
        else if (field.key === 'school_medium' || field.displayName.toLowerCase().includes('medium')) {
          if (!/^[a-zA-Z\s]$/.test(key)) {
            event.preventDefault();
          }
        }
      },
      getChildPreviousSchoolDetails() {
        const data = { learner: this.learner };
        axios
          .post("/parent/getChildPreviousSchoolDetails", data)
          .then((res) => {
            if (res.data.flag === "YES") {
              this.schoolAttended = res.data.schoolAttended || {};
              this.standard_list = res.data.standard_list || [];
              this.previousschoolschoolboard_list = res.data.previousschoolschoolboard_list || [];
              this.$nextTick(() => {
                this.formatPercentageDisplay();
              });
            } else {
              this.showSnackbar("error", res.data.snackbar || "Something went wrong...");
            }
          })
          .catch(() => {
            this.showSnackbar("error", "Server error occurred.");
          });
      },
      formatPercentageDisplay() {
        const key = "previous_school_obtained_percentage";
        const field = this.schoolAttended[key];
        if (!field) return;

        const value = field.value;

        // Only add % if value exists and doesn't already end with %
        if (value !== null && value !== undefined && value !== "" && value !== false) {
          const str = String(value).trim();
          if (str && !str.endsWith("%")) {
            field.value = str + "%";
          }
        }
      },
      // 1. Helper methods
      isSchoolName(displayName) {
        return displayName.toLowerCase().includes('previous school name') ||
          displayName.toLowerCase().includes('school name');
      },
      isPercentageField(displayName) {
        return displayName.toLowerCase().includes('obtained percentage') || displayName.toLowerCase().includes('percentage');
      },

      // 2. Keypress blockers
      blockSpecialChars(event) {
        const char = String.fromCharCode(event.keyCode || event.which);
        if (!/[a-zA-Z0-9\s'\-\(\),.]/.test(char)) {
          event.preventDefault();
        }
      },
      onlyDigitsAndDot(event) {
        const char = String.fromCharCode(event.keyCode || event.which);
        if (!/[0-9.]/.test(char)) event.preventDefault();
        if (char === '.' && event.target.value.includes('.')) event.preventDefault();
      },
      saveChildPreviousSchoolDetails() {
        this.save_loader = true;

        // Required field validation
        for (let key in this.schoolAttended) {
          const f = this.schoolAttended[key];
          if (f.required && f.isactive) {
            if ((f.value === null || f.value === undefined || f.value === "") && f.type !== "checkbox") {
              this.showSnackbar("error", `Please enter ${f.displayName}`);
              this.save_loader = false;
              return;
            }
            if (f.type === "checkbox" && f.value !== true) {
              this.showSnackbar("error", `Please select ${f.displayName}`);
              this.save_loader = false;
              return;
            }
          }
        }

        const payload = { learner: this.learner };

        for (let key in this.schoolAttended) {
          const field = this.schoolAttended[key];
          if (!field.isactive) continue;

          let rawValue = field.value;
          let valueToSend = rawValue;
          const displayNameLower = field.displayName.toLowerCase();

          // 1️⃣ School Name validation
          if (this.isSchoolName(field.displayName)) {
            if (rawValue && typeof rawValue === "string") {
              const cleaned = rawValue.trim();

              // Letters (A-Z a-z), spaces, apostrophe ’ (both straight ' and curly ’), dot, parentheses, hyphen allowed
              // Note: Added both ' and ’ apostrophes
              const schoolNameRegex = /^[A-Za-z\s'.’().\-]+$/;

              if (!schoolNameRegex.test(cleaned)) {
                this.showSnackbar(
                  "error",
                  "School Name can contain only letters and basic symbols like ' . - ()"
                );
                this.save_loader = false;
                return;
              }

              valueToSend = cleaned || null;
            }
          }

          // 2️⃣ School Medium validation
          else if (displayNameLower.includes("medium") || key === "school_medium") {
            if (rawValue && typeof rawValue === "string") {
              const cleaned = rawValue.trim();

              // Letters and spaces only
              if (!/^[A-Za-z\s]+$/.test(cleaned)) {
                this.showSnackbar("error", "School Medium must contain only letters");
                this.save_loader = false;
                return;
              }

              valueToSend = cleaned || null;
            }
          }

          // 3️⃣ Percentage validation
          else if (key === "previous_school_obtained_percentage") {
            if (rawValue !== null && rawValue !== undefined && rawValue !== "") {
              const input = String(rawValue).trim();

              // Must be digits followed by %
              const percentRegex = /^[0-9]{1,3}%$/;

              if (!percentRegex.test(input)) {
                this.showSnackbar(
                  "error",
                  "Percentage must be digits followed by % (Example: 10%, 95%)"
                );
                this.save_loader = false;
                return;
              }

              const numberVal = parseInt(input.slice(0, -1), 10);
              if (numberVal < 0 || numberVal > 100) {
                this.showSnackbar("error", "Percentage must be between 0 and 100");
                this.save_loader = false;
                return;
              }

              valueToSend = numberVal; // Send number to backend
            } else {
              valueToSend = null;
            }
          }

          // Other Grade / Marks / Percentage fields (if any)
          else if (
            displayNameLower.includes("marks") ||
            displayNameLower.includes("grade") ||
            (displayNameLower.includes("percentage") && key !== "previous_school_obtained_percentage")
          ) {
            if (rawValue !== null && rawValue !== undefined && rawValue !== "") {
              const input = String(rawValue).trim().toUpperCase();
              const cleanForCheck = input.replace(/\s|%/g, "");

              const validGrades = /^(A\+?|A-|A1|A2|B\+{0,2}|B-|C\+?|C|D\+?|O|F)$/;

              if (!validGrades.test(cleanForCheck)) {
                this.showSnackbar(
                  "error",
                  "Enter a valid grade like A+, A1, B++, O"
                );
                this.save_loader = false;
                return;
              }

              valueToSend = cleanForCheck;
            } else {
              valueToSend = null;
            }
          }

          payload[key] = valueToSend;
        }



        // Final API call
        axios.post("/parent/saveChildPreviousSchoolDetails", payload)
          .then((res) => {
            if (res.data.flag === "YES") {
              this.showSnackbar("success", res.data.snackbar || "Save Successfully!");
              this.getChildPreviousSchoolDetails(); // Refresh data
            } else {
              this.showSnackbar("error", res.data.snackbar || "Something went wrong...");
            }
          })
          .catch(() => {
            this.showSnackbar("error", "Server error occurred.");
          })
          .finally(() => {
            this.save_loader = false;
          });
      },


      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      },
    },
    mounted() {
      this.getChildPreviousSchoolDetails();
    },
  };
</script>

<style scoped>
  .button-77 {
    /* background-color: initial; */
    /* border-style: none; */
    color: #fff;
    cursor: pointer;
    /* font-size: 16px; */
    font-weight: 800;
    vertical-align: middle;
    z-index: 0;
    /* padding: 19px 16px; */
  }

  /* @media (min-width: 768px) {
  .button-77 {
    padding: 19px 32px;
  }
} */

  .button-77:before,
  .button-77:after {
    border-radius: 80px;
  }

  .button-77:before {
    background-color: rgba(249, 58, 19, .32);
    content: "";
  }

  .button-77:after {
    /* background-color: initial; */
    background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    content: "";
    display: block;
    left: 4px;
    overflow: hidden;
    position: absolute;
    right: 4px;
    top: 4px;
    transition: all 100ms ease-out;
    z-index: -1;
  }

  .button-77:hover:not(:disabled):after {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transition-timing-function: ease-in;
  }

  .button-77:active:not(:disabled) {
    color: #ccc;
  }

  .button-77:active:not(:disabled):after {
    background-image: linear-gradient(0deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, .2)), linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
    bottom: 4px;
    left: 4px;
    right: 4px;
    top: 4px;
  }

  .button-77:disabled {
    cursor: default;
    opacity: .24;
  }

  .main-card {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .custom-toolbar {
    background: linear-gradient(to right, #a8edea, #e4d0ff);
  }
</style>